import { PaginationData, ApplyPromoCodePayload } from "src/types/api";
import { baseInstance } from "src/api";

export const getReferrals = async (payload: PaginationData) => {
  try {
    return await baseInstance.get(
      `user/referrals/?page=${payload.page}&page_size=${payload.size}`
    );
  } catch (err: any) {
    return err;
  }
};

export const getPromoCode = async () => {
  try {
    return await baseInstance.get(`user/promo-code/`);
  } catch (err: any) {
    return err;
  }
};

export const applyPromoCode = async (payload: ApplyPromoCodePayload) => {
  try {
    return await baseInstance.post("user/apply-promo-code/", payload);
  } catch (err: any) {
    return err;
  }
};
